import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { map, Observable } from 'rxjs';
import { BillingType } from '@pncl/common-models';
import { PaymentService } from 'src/app/services/payment.service';
import { UserService } from 'src/app/services/user.service';
import { PanelData } from '../../settings.constants';
@UntilDestroy()
@Component({
  selector: 'app-user-settings-billable-usage',
  templateUrl: './user-settings-billable-usage.component.html',
  styleUrls: ['./user-settings-billable-usage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSettingsBillableUsageComponent {
  @Input() panelData!: PanelData;
  @Input() isMobile = false;
  @Output() goBack = new EventEmitter<void>();
  protected isAutomaticBillingWithVisiblePlans$: Observable<boolean>;
  protected isSeatBased$: Observable<boolean>;
  protected selectedTabIndex = 0;

  constructor(private userService: UserService, private paymentService: PaymentService) {
    this.isAutomaticBillingWithVisiblePlans$ = this.userService.user.pipe(
      map(
        (res) =>
          res?.user?.institution?.paywallConfig?.billingType === BillingType.Automatic &&
          !res?.user?.institution?.paywallConfig?.hidePaymentPlans,
      ),
    );
    this.isSeatBased$ = this.userService.user.pipe(
      map((res) => this.paymentService.isSeatBasedInstitution(res?.user?.institution)),
    );
  }

  protected goToAllPlans(): void {
    this.selectedTabIndex = 1;
  }
}
